
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-filters-starter-pack",
      function () {
        return require("private-next-pages/ai-filters-starter-pack/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-filters-starter-pack"])
      });
    }
  